{
  "no-video-available": {
    "en": "No Video Available",
    "ar": "لا يوجد فيديو متاح",
    "id": "Tidak ada video tersedia"
  },
  "help-title": {
    "en": "Hi, How can we help?",
    "ar": "مرحباً، كيف يمكننا مساعدتك؟",
    "id": "Hai, Bagaimana kami bisa membantu?"
  },
  "help-search-placeholder": {
    "en": "Search your question here...",
    "ar": "ابحث عن سؤالك هنا...",
    "id": "Cari pertanyaan Anda di sini..."
  },
  "help-account-login": {
    "en": "Account & Login",
    "ar": "الحساب وتسجيل الدخول",
    "id": "Akun & Login"
  },
  "help-create-account": {
    "en": "Create Account",
    "ar": "إنشاء حساب",
    "id": "Buat Akun"
  },
  "help-reset-password": {
    "en": "Reset Password",
    "ar": "إعادة تعيين كلمة المرور",
    "id": "Reset Password"
  },
  "help-email-verification": {
    "en": "Email Verification",
    "ar": "التحقق من البريد الإلكتروني",
    "id": "Verifikasi Email"
  },
  "help-delete-deactivate": {
    "en": "Delete or Deactivate Account",
    "ar": "حذف أو تعطيل الحساب",
    "id": "Hapus atau Nonaktifkan Akun"
  },
  "help-candidate-profile": {
    "en": "Candidate Profile",
    "ar": "ملف المرشح",
    "id": "Profil Kandidat"
  },
  "help-complete-profile": {
    "en": "Complete Profile",
    "ar": "استكمال الملف الشخصي",
    "id": "Lengkapi Profil"
  },
  "help-optimization-tips": {
    "en": "Profile Optimization Tips",
    "ar": "نصائح تحسين الملف الشخصي",
    "id": "Tips Optimalisasi Profil"
  },
  "help-upload-resume": {
    "en": "Upload / Update Resume",
    "ar": "رفع / تحديث السيرة الذاتية",
    "id": "Unggah / Perbarui Resume"
  },
  "help-privacy-settings": {
    "en": "Profile Privacy Settings",
    "ar": "إعدادات خصوصية الملف الشخصي",
    "id": "Pengaturan Privasi Profil"
  },
  "help-skills-portfolio": {
    "en": "Add Skills & Portfolio",
    "ar": "إضافة المهارات والمحفظة",
    "id": "Tambah Keterampilan & Portofolio"
  },
  "help-recruiter-guide": {
    "en": "Recruiter / Employer Guide",
    "ar": "دليل المجند / صاحب العمل",
    "id": "Panduan Rekruter / Pemberi Kerja"
  },
  "help-create-company-page": {
    "en": "Create Company Page",
    "ar": "إنشاء صفحة الشركة",
    "id": "Buat Halaman Perusahaan"
  },
  "help-post-job": {
    "en": "Post a Job",
    "ar": "نشر وظيفة",
    "id": "Pasang Lowongan"
  },
  "help-manage-applications": {
    "en": "Manage Applications",
    "ar": "إدارة الطلبات",
    "id": "Kelola Lamaran"
  },
  "help-search-candidates": {
    "en": "Search for Candidates",
    "ar": "البحث عن المرشحين",
    "id": "Cari Kandidat"
  },
  "help-schedule-interviews": {
    "en": "Schedule Interviews",
    "ar": "جدولة المقابلات",
    "id": "Jadwalkan Wawancara"
  },
  "help-job-search-application": {
    "en": "Job Search & Application",
    "ar": "البحث عن وظيفة والتقديم",
    "id": "Pencarian & Lamaran Kerja"
  },
  "help-search-guide": {
    "en": "Job Search Guide",
    "ar": "دليل البحث عن وظيفة",
    "id": "Panduan Pencarian Kerja"
  },
  "help-save-jobs": {
    "en": "Save Jobs for Later",
    "ar": "حفظ الوظائف للاطلاع لاحقاً",
    "id": "Simpan Lowongan untuk Nanti"
  },
  "help-apply-jobs": {
    "en": "Apply for Jobs",
    "ar": "التقدم للوظائف",
    "id": "Lamar Pekerjaan"
  },
  "help-track-applications": {
    "en": "Track Application Status",
    "ar": "تتبع حالة الطلب",
    "id": "Lacak Status Lamaran"
  },
  "help-recommendations": {
    "en": "Job Recommendations",
    "ar": "توصيات الوظائف",
    "id": "Rekomendasi Pekerjaan"
  },
  "help-messaging-communication": {
    "en": "Messaging & Communication",
    "ar": "المراسلة والتواصل",
    "id": "Pesan & Komunikasi"
  },
  "help-send-messages": {
    "en": "Send Messages",
    "ar": "إرسال الرسائل",
    "id": "Kirim Pesan"
  },
  "help-message-limits": {
    "en": "Limit Who Can Message You",
    "ar": "تحديد من يمكنه مراسلتك",
    "id": "Batasi Siapa yang Bisa Mengirim Pesan"
  },
  "help-interview-invites": {
    "en": "View Interview Invites",
    "ar": "عرض دعوات المقابلة",
    "id": "Lihat Undangan Wawancara"
  },
  "help-report-abuse": {
    "en": "Report Spam / Abuse",
    "ar": "الإبلاغ عن البريد المزعج / الإساءة",
    "id": "Laporkan Spam / Penyalahgunaan"
  },
  "help-notifications-alerts": {
    "en": "Notifications & Alerts",
    "ar": "الإشعارات والتنبيهات",
    "id": "Notifikasi & Peringatan"
  },
  "help-job-alerts": {
    "en": "Manage Job Alerts",
    "ar": "إدارة تنبيهات الوظائف",
    "id": "Kelola Peringatan Pekerjaan"
  },
  "help-email-settings": {
    "en": "Email Notification Settings",
    "ar": "إعدادات إشعارات البريد الإلكتروني",
    "id": "Pengaturan Notifikasi Email"
  },
  "help-privacy-security": {
    "en": "Privacy & Security",
    "ar": "الخصوصية والأمان",
    "id": "Privasi & Keamanan"
  },
  "help-profile-privacy": {
    "en": "Profile Privacy Options",
    "ar": "خيارات خصوصية الملف الشخصي",
    "id": "Opsi Privasi Profil"
  },
  "help-public-private": {
    "en": "Public vs Private Profile",
    "ar": "الملف الشخصي العام مقابل الخاص",
    "id": "Profil Publik vs Privat"
  },
  "help-report-fake-accounts": {
    "en": "Report Fake Accounts",
    "ar": "الإبلاغ عن الحسابات المزيفة",
    "id": "Laporkan Akun Palsu"
  },
  "help-technical-support": {
    "en": "Technical Support",
    "ar": "الدعم الفني",
    "id": "Dukungan Teknis"
  },
  "help-troubleshooting": {
    "en": "Website Issues & Troubleshooting",
    "ar": "مشاكل الموقع واستكشاف الأخطاء",
    "id": "Masalah Website & Pemecahan Masalah"
  },
  "privacy-last-updated": {
    "en": "Last Updated:",
    "ar": "آخر تحديث:",
    "id": "Terakhir Diperbarui:"
  },
  "privacy-intro": {
    "en": "This Privacy Policy explains how we collect, use, disclose, and protect your personal information when you use our HR Management Platform. We are committed to maintaining the confidentiality and security of your data.",
    "ar": "توضح سياسة الخصوصية هذه كيفية جمع واستخدام والإفصاح عن معلوماتك الشخصية وحمايتها عند استخدام منصة إدارة الموارد البشرية الخاصة بنا. نحن ملتزمون بالحفاظ على سرية وأمان بياناتك.",
    "id": "Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, mengungkapkan, dan melindungi informasi pribadi Anda saat menggunakan Platform Manajemen SDM kami. Kami berkomitmen untuk menjaga kerahasiaan dan keamanan data Anda."
  },
  "privacy-matters-title": {
    "en": "Your Privacy Matters:",
    "ar": "خصوصيتك مهمة:",
    "id": "Privasi Anda Penting:"
  },
  "privacy-matters-text": {
    "en": "We are committed to protecting your personal information and maintaining transparency about our data practices. If you have any questions or concerns, please don't hesitate to contact us.",
    "ar": "نحن ملتزمون بحماية معلوماتك الشخصية والحفاظ على الشفافية بشأن ممارسات البيانات لدينا. إذا كان لديك أي أسئلة أو استفسارات، فلا تتردد في الاتصال بنا.",
    "id": "Kami berkomitmen untuk melindungi informasi pribadi Anda dan menjaga transparansi tentang praktik data kami. Jika Anda memiliki pertanyaan atau kekhawatiran, jangan ragu untuk menghubungi kami."
  },
  "privacy-section-1-title": {
    "en": "1. Information We Collect",
    "ar": "1. المعلومات التي نجمعها",
    "id": "1. Informasi yang Kami Kumpulkan"
  },
  "privacy-section-1-content": {
    "en": "We collect various types of information to provide and improve our HR Management Platform services:\n\n• Personal Information: Name, email address, phone number, job title, employee ID, and other identification information.\n• Employment Data: Work history, performance reviews, compensation details, benefits enrollment, attendance records, and professional qualifications.\n• Authentication Data: Login credentials, security questions, and authentication tokens.\n• Usage Information: Log data, IP addresses, browser type, and interaction with the platform.\n• Documents: Resumes, contracts, certificates, and other work-related documents you upload.\n\nWe only collect information that is necessary for HR operations and with proper authorization.",
    "ar": "نجمع أنواعًا مختلفة من المعلومات لتقديم خدمات منصة إدارة الموارد البشرية وتحسينها:\n\n• المعلومات الشخصية: الاسم وعنوان البريد الإلكتروني ورقم الهاتف والمسمى الوظيفي ورقم الموظف ومعلومات التعريف الأخرى.\n• بيانات التوظيف: سجل العمل ومراجعات الأداء وتفاصيل التعويض والتسجيل في المزايا وسجلات الحضور والمؤهلات المهنية.\n• بيانات المصادقة: بيانات اعتماد تسجيل الدخول وأسئلة الأمان ورموز المصادقة.\n• معلومات الاستخدام: بيانات السجل وعناوين IP ونوع المتصفح والتفاعل مع المنصة.\n• المستندات: السير الذاتية والعقود والشهادات وغيرها من المستندات المتعلقة بالعمل التي تقوم بتحميلها.\n\nنحن نجمع فقط المعلومات الضرورية لعمليات الموارد البشرية وبالتفويض المناسب.",
    "id": "Kami mengumpulkan berbagai jenis informasi untuk menyediakan dan meningkatkan layanan Platform Manajemen SDM kami:\n\n• Informasi Pribadi: Nama, alamat email, nomor telepon, jabatan, ID karyawan, dan informasi identifikasi lainnya.\n• Data Ketenagakerjaan: Riwayat kerja, ulasan kinerja, detail kompensasi, pendaftaran tunjangan, catatan kehadiran, dan kualifikasi profesional.\n• Data Otentikasi: Kredensial login, pertanyaan keamanan, dan token otentikasi.\n• Informasi Penggunaan: Data log, alamat IP, jenis browser, dan interaksi dengan platform.\n• Dokumen: Resume, kontrak, sertifikat, dan dokumen terkait pekerjaan lainnya yang Anda unggah.\n\nKami hanya mengumpulkan informasi yang diperlukan untuk operasi SDM dan dengan otorisasi yang tepat."
  },
  "privacy-section-2-title": {
    "en": "2. How We Use Your Information",
    "ar": "2. كيف نستخدم معلوماتك",
    "id": "2. Bagaimana Kami Menggunakan Informasi Anda"
  },
  "privacy-section-2-content": {
    "en": "Your information is used for legitimate business purposes including:\n\n• Managing employee records and HR operations\n• Processing payroll and benefits administration\n• Conducting performance evaluations and reviews\n• Facilitating recruitment and onboarding processes\n• Ensuring compliance with labor laws and regulations\n• Communicating important updates and announcements\n• Improving platform functionality and user experience\n• Maintaining security and preventing unauthorized access\n• Generating reports and analytics for organizational planning\n\nWe do not sell or share your personal information with third parties for marketing purposes.",
    "ar": "تُستخدم معلوماتك لأغراض تجارية مشروعة تشمل:\n\n• إدارة سجلات الموظفين وعمليات الموارد البشرية\n• معالجة الرواتب وإدارة المزايا\n• إجراء تقييمات ومراجعات الأداء\n• تسهيل عمليات التوظيف والتأهيل\n• ضمان الامتثال لقوانين ولوائح العمل\n• إرسال التحديثات والإعلانات المهمة\n• تحسين وظائف المنصة وتجربة المستخدم\n• الحفاظ على الأمان ومنع الوصول غير المصرح به\n• إنشاء التقارير والتحليلات للتخطيط المؤسسي\n\nنحن لا نبيع أو نشارك معلوماتك الشخصية مع أطراف ثالثة لأغراض تسويقية.",
    "id": "Informasi Anda digunakan untuk tujuan bisnis yang sah termasuk:\n\n• Mengelola catatan karyawan dan operasi SDM\n• Memproses penggajian dan administrasi tunjangan\n• Melakukan evaluasi dan ulasan kinerja\n• Memfasilitasi proses rekrutmen dan orientasi\n• Memastikan kepatuhan terhadap undang-undang dan peraturan ketenagakerjaan\n• Mengomunikasikan pembaruan dan pengumuman penting\n• Meningkatkan fungsionalitas platform dan pengalaman pengguna\n• Menjaga keamanan dan mencegah akses tidak sah\n• Menghasilkan laporan dan analitik untuk perencanaan organisasi\n\nKami tidak menjual atau membagikan informasi pribadi Anda kepada pihak ketiga untuk tujuan pemasaran."
  },
  "privacy-section-3-title": {
    "en": "3. Data Storage and Security",
    "ar": "3. تخزين البيانات والأمان",
    "id": "3. Penyimpanan Data dan Keamanan"
  },
  "privacy-section-3-content": {
    "en": "We implement robust security measures to protect your information:\n\n• Data Encryption: All sensitive data is encrypted both in transit and at rest using industry-standard encryption protocols.\n• Access Controls: Role-based access controls ensure only authorized personnel can view specific information.\n• Secure Infrastructure: Our servers are hosted in secure facilities with physical and digital security measures.\n• Regular Backups: Data is regularly backed up to prevent loss.\n• Security Monitoring: Continuous monitoring for suspicious activities and potential security threats.\n• Compliance: We comply with relevant data protection regulations including GDPR, CCPA, and other applicable laws.\n\nDespite our security measures, no system is completely secure. Please report any security concerns immediately.",
    "ar": "نطبق إجراءات أمان قوية لحماية معلوماتك:\n\n• تشفير البيانات: يتم تشفير جميع البيانات الحساسة أثناء النقل وفي حالة الراحة باستخدام بروتوكولات التشفير القياسية في الصناعة.\n• ضوابط الوصول: تضمن ضوابط الوصول القائمة على الأدوار أن الموظفين المصرح لهم فقط يمكنهم عرض معلومات محددة.\n• البنية التحتية الآمنة: تتم استضافة خوادمنا في منشآت آمنة مع إجراءات أمان مادية ورقمية.\n• النسخ الاحتياطي المنتظم: يتم نسخ البيانات احتياطيًا بشكل منتظم لمنع الفقدان.\n• مراقبة الأمان: مراقبة مستمرة للأنشطة المشبوهة والتهديدات الأمنية المحتملة.\n• الامتثال: نلتزم بلوائح حماية البيانات ذات الصلة بما في ذلك GDPR و CCPA والقوانين الأخرى المعمول بها.\n\nعلى الرغم من إجراءاتنا الأمنية، لا يوجد نظام آمن تمامًا. يرجى الإبلاغ عن أي مخاوف أمنية على الفور.",
    "id": "Kami menerapkan langkah-langkah keamanan yang kuat untuk melindungi informasi Anda:\n\n• Enkripsi Data: Semua data sensitif dienkripsi baik saat transit maupun saat istirahat menggunakan protokol enkripsi standar industri.\n• Kontrol Akses: Kontrol akses berbasis peran memastikan hanya personel yang berwenang yang dapat melihat informasi tertentu.\n• Infrastruktur Aman: Server kami dihosting di fasilitas yang aman dengan langkah-langkah keamanan fisik dan digital.\n• Backup Reguler: Data dicadangkan secara teratur untuk mencegah kehilangan.\n• Pemantauan Keamanan: Pemantauan berkelanjutan untuk aktivitas mencurigakan dan potensi ancaman keamanan.\n• Kepatuhan: Kami mematuhi peraturan perlindungan data yang relevan termasuk GDPR, CCPA, dan undang-undang lain yang berlaku.\n\nMeskipun ada langkah-langkah keamanan kami, tidak ada sistem yang sepenuhnya aman. Harap laporkan masalah keamanan segera."
  },
  "privacy-section-4-title": {
    "en": "4. Data Retention",
    "ar": "4. الاحتفاظ بالبيانات",
    "id": "4. Retensi Data"
  },
  "privacy-section-4-content": {
    "en": "We retain your personal information for as long as necessary to fulfill the purposes outlined in this privacy policy:\n\n• Active Employment: Data is maintained throughout your employment period.\n• Post-Employment: After termination, we retain certain records as required by law (typically 3-7 years depending on jurisdiction and record type).\n• Legal Requirements: Some information may be retained longer to comply with legal obligations, resolve disputes, or enforce agreements.\n• Deletion Requests: You may request deletion of your data, subject to legal retention requirements.\n\nWhen data is no longer needed, it is securely deleted or anonymized.",
    "ar": "نحتفظ بمعلوماتك الشخصية طالما كان ذلك ضروريًا لتحقيق الأغراض الموضحة في سياسة الخصوصية هذه:\n\n• التوظيف النشط: يتم الاحتفاظ بالبيانات طوال فترة عملك.\n• ما بعد التوظيف: بعد انتهاء الخدمة، نحتفظ بسجلات معينة كما يقتضي القانون (عادةً 3-7 سنوات حسب الاختصاص القضائي ونوع السجل).\n• المتطلبات القانونية: قد يتم الاحتفاظ ببعض المعلومات لفترة أطول للامتثال للالتزامات القانونية أو حل النزاعات أو تنفيذ الاتفاقيات.\n• طلبات الحذف: يمكنك طلب حذف بياناتك، مع مراعاة متطلبات الاحتفاظ القانونية.\n\nعندما لا تكون البيانات مطلوبة، يتم حذفها بشكل آمن أو إخفاء هويتها.",
    "id": "Kami menyimpan informasi pribadi Anda selama diperlukan untuk memenuhi tujuan yang diuraikan dalam kebijakan privasi ini:\n\n• Pekerjaan Aktif: Data dipelihara sepanjang periode pekerjaan Anda.\n• Pasca-Pekerjaan: Setelah pemutusan, kami menyimpan catatan tertentu sebagaimana diwajibkan oleh hukum (biasanya 3-7 tahun tergantung pada yurisdiksi dan jenis catatan).\n• Persyaratan Hukum: Beberapa informasi mungkin disimpan lebih lama untuk mematuhi kewajiban hukum, menyelesaikan perselisihan, atau menegakkan perjanjian.\n• Permintaan Penghapusan: Anda dapat meminta penghapusan data Anda, tunduk pada persyaratan retensi hukum.\n\nKetika data tidak lagi diperlukan, data tersebut dihapus dengan aman atau dianonimkan."
  },
  "privacy-section-5-title": {
    "en": "5. Data Sharing and Third Parties",
    "ar": "5. مشاركة البيانات والأطراف الثالثة",
    "id": "5. Berbagi Data dan Pihak Ketiga"
  },
  "privacy-section-5-content": {
    "en": "We may share your information only in the following circumstances:\n\n• Service Providers: Trusted third-party vendors who assist with payroll, benefits administration, or platform infrastructure (under strict confidentiality agreements).\n• Legal Compliance: When required by law, court order, or government investigation.\n• Business Transfers: In the event of a merger, acquisition, or asset sale (you will be notified of any change in ownership).\n• With Your Consent: When you explicitly authorize information sharing.\n\nWe do not sell your personal information to third parties. All third-party providers are carefully vetted and contractually obligated to protect your data.",
    "ar": "قد نشارك معلوماتك فقط في الظروف التالية:\n\n• مقدمو الخدمات: البائعون الموثوقون من الأطراف الثالثة الذين يساعدون في الرواتب أو إدارة المزايا أو البنية التحتية للمنصة (بموجب اتفاقيات سرية صارمة).\n• الامتثال القانوني: عندما يقتضي القانون أو أمر المحكمة أو التحقيق الحكومي.\n• نقل الأعمال: في حالة الاندماج أو الاستحواذ أو بيع الأصول (سيتم إخطارك بأي تغيير في الملكية).\n• بموافقتك: عندما تصرح صراحةً بمشاركة المعلومات.\n\nنحن لا نبيع معلوماتك الشخصية لأطراف ثالثة. يتم فحص جميع مقدمي الخدمات من الأطراف الثالثة بعناية وإلزامهم تعاقديًا بحماية بياناتك.",
    "id": "Kami mungkin membagikan informasi Anda hanya dalam keadaan berikut:\n\n• Penyedia Layanan: Vendor pihak ketiga tepercaya yang membantu penggajian, administrasi tunjangan, atau infrastruktur platform (di bawah perjanjian kerahasiaan yang ketat).\n• Kepatuhan Hukum: Ketika diwajibkan oleh hukum, perintah pengadilan, atau investigasi pemerintah.\n• Transfer Bisnis: Dalam hal merger, akuisisi, atau penjualan aset (Anda akan diberi tahu tentang perubahan kepemilikan).\n• Dengan Persetujuan Anda: Ketika Anda secara eksplisit mengizinkan berbagi informasi.\n\nKami tidak menjual informasi pribadi Anda kepada pihak ketiga. Semua penyedia pihak ketiga diperiksa dengan cermat dan diwajibkan secara kontraktual untuk melindungi data Anda."
  },
  "privacy-section-6-title": {
    "en": "6. Your Privacy Rights",
    "ar": "6. حقوق الخصوصية الخاصة بك",
    "id": "6. Hak Privasi Anda"
  },
  "privacy-section-6-content": {
    "en": "You have the following rights regarding your personal information:\n\n• Access: Request copies of your personal data held by the organization.\n• Correction: Request correction of inaccurate or incomplete information.\n• Deletion: Request deletion of your data (subject to legal retention requirements).\n• Restriction: Request limitation on how your data is processed.\n• Portability: Request your data in a portable format.\n• Objection: Object to certain types of processing.\n• Withdraw Consent: Withdraw previously given consent at any time.\n\nTo exercise these rights, contact your HR department or system administrator. We will respond to requests within the timeframe required by applicable law.",
    "ar": "لديك الحقوق التالية فيما يتعلق بمعلوماتك الشخصية:\n\n• الوصول: طلب نسخ من بياناتك الشخصية التي تحتفظ بها المنظمة.\n• التصحيح: طلب تصحيح المعلومات غير الدقيقة أو غير المكتملة.\n• الحذف: طلب حذف بياناتك (مع مراعاة متطلبات الاحتفاظ القانونية).\n• التقييد: طلب تقييد كيفية معالجة بياناتك.\n• قابلية النقل: طلب بياناتك بتنسيق قابل للنقل.\n• الاعتراض: الاعتراض على أنواع معينة من المعالجة.\n• سحب الموافقة: سحب الموافقة الممنوحة مسبقًا في أي وقت.\n\nلممارسة هذه الحقوق، اتصل بقسم الموارد البشرية أو مسؤول النظام. سنرد على الطلبات في الإطار الزمني الذي يتطلبه القانون المعمول به.",
    "id": "Anda memiliki hak-hak berikut mengenai informasi pribadi Anda:\n\n• Akses: Meminta salinan data pribadi Anda yang dipegang oleh organisasi.\n• Koreksi: Meminta koreksi informasi yang tidak akurat atau tidak lengkap.\n• Penghapusan: Meminta penghapusan data Anda (tunduk pada persyaratan retensi hukum).\n• Pembatasan: Meminta pembatasan cara data Anda diproses.\n• Portabilitas: Meminta data Anda dalam format portabel.\n• Keberatan: Menolak jenis pemrosesan tertentu.\n• Tarik Persetujuan: Menarik persetujuan yang telah diberikan sebelumnya kapan saja.\n\nUntuk menggunakan hak-hak ini, hubungi departemen SDM atau administrator sistem Anda. Kami akan merespons permintaan dalam jangka waktu yang diwajibkan oleh hukum yang berlaku."
  },
  "privacy-section-7-title": {
    "en": "7. Cookies and Tracking Technologies",
    "ar": "7. ملفات تعريف الارتباط وتقنيات التتبع",
    "id": "7. Cookie dan Teknologi Pelacakan"
  },
  "privacy-section-7-content": {
    "en": "Our platform uses cookies and similar technologies to enhance user experience:\n\n• Essential Cookies: Required for basic platform functionality and security.\n• Preference Cookies: Remember your settings and preferences.\n• Analytics Cookies: Help us understand how users interact with the platform.\n• Session Management: Maintain your login session.\n\nYou can control cookie preferences through your browser settings, though disabling certain cookies may affect platform functionality.",
    "ar": "تستخدم منصتنا ملفات تعريف الارتباط والتقنيات المماثلة لتحسين تجربة المستخدم:\n\n• ملفات تعريف الارتباط الأساسية: مطلوبة لوظائف المنصة الأساسية والأمان.\n• ملفات تعريف الارتباط التفضيلية: تتذكر إعداداتك وتفضيلاتك.\n• ملفات تعريف الارتباط التحليلية: تساعدنا على فهم كيفية تفاعل المستخدمين مع المنصة.\n• إدارة الجلسة: الحفاظ على جلسة تسجيل الدخول الخاصة بك.\n\nيمكنك التحكم في تفضيلات ملفات تعريف الارتباط من خلال إعدادات المتصفح، على الرغم من أن تعطيل بعض ملفات تعريف الارتباط قد يؤثر على وظائف المنصة.",
    "id": "Platform kami menggunakan cookie dan teknologi serupa untuk meningkatkan pengalaman pengguna:\n\n• Cookie Esensial: Diperlukan untuk fungsionalitas dan keamanan platform dasar.\n• Cookie Preferensi: Mengingat pengaturan dan preferensi Anda.\n• Cookie Analitik: Membantu kami memahami bagaimana pengguna berinteraksi dengan platform.\n• Manajemen Sesi: Mempertahankan sesi login Anda.\n\nAnda dapat mengontrol preferensi cookie melalui pengaturan browser Anda, meskipun menonaktifkan cookie tertentu dapat mempengaruhi fungsionalitas platform."
  },
  "privacy-section-8-title": {
    "en": "8. Children's Privacy",
    "ar": "8. خصوصية الأطفال",
    "id": "8. Privasi Anak-anak"
  },
  "privacy-section-8-content": {
    "en": "This platform is not intended for individuals under the age of 18. We do not knowingly collect personal information from minors. If we become aware that we have inadvertently collected data from a minor, we will take steps to delete it promptly.",
    "ar": "هذه المنصة غير مخصصة للأفراد الذين تقل أعمارهم عن 18 عامًا. نحن لا نجمع عن قصد معلومات شخصية من القاصرين. إذا علمنا أننا جمعنا عن غير قصد بيانات من قاصر، سنتخذ خطوات لحذفها على الفور.",
    "id": "Platform ini tidak ditujukan untuk individu di bawah usia 18 tahun. Kami tidak dengan sengaja mengumpulkan informasi pribadi dari anak di bawah umur. Jika kami menyadari bahwa kami secara tidak sengaja mengumpulkan data dari anak di bawah umur, kami akan mengambil langkah untuk menghapusnya segera."
  },
  "privacy-section-9-title": {
    "en": "9. International Data Transfers",
    "ar": "9. نقل البيانات الدولية",
    "id": "9. Transfer Data Internasional"
  },
  "privacy-section-9-content": {
    "en": "If you are accessing this platform from outside the country where our servers are located, your information may be transferred across borders. We ensure appropriate safeguards are in place for international data transfers in accordance with applicable data protection laws.",
    "ar": "إذا كنت تصل إلى هذه المنصة من خارج البلد الذي توجد فيه خوادمنا، فقد يتم نقل معلوماتك عبر الحدود. نحن نضمن وجود ضمانات مناسبة لعمليات نقل البيانات الدولية وفقًا لقوانين حماية البيانات المعمول بها.",
    "id": "Jika Anda mengakses platform ini dari luar negara tempat server kami berada, informasi Anda mungkin ditransfer melintasi batas negara. Kami memastikan perlindungan yang sesuai tersedia untuk transfer data internasional sesuai dengan undang-undang perlindungan data yang berlaku."
  },
  "privacy-section-10-title": {
    "en": "10. Changes to This Privacy Policy",
    "ar": "10. التغييرات على سياسة الخصوصية هذه",
    "id": "10. Perubahan pada Kebijakan Privasi Ini"
  },
  "privacy-section-10-content": {
    "en": "We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. When we make significant changes:\n\n• You will be notified via email or platform notification\n• The 'Last Updated' date will be revised\n• Continued use of the platform after changes constitutes acceptance\n\nWe encourage you to review this policy regularly to stay informed about how we protect your information.",
    "ar": "قد نقوم بتحديث سياسة الخصوصية هذه بشكل دوري لتعكس التغييرات في ممارساتنا أو المتطلبات القانونية. عندما نجري تغييرات جوهرية:\n\n• سيتم إخطارك عبر البريد الإلكتروني أو إشعار المنصة\n• سيتم تعديل تاريخ \"آخر تحديث\"\n• يعتبر الاستمرار في استخدام المنصة بعد التغييرات قبولاً\n\nنشجعك على مراجعة هذه السياسة بانتظام للبقاء على اطلاع بكيفية حماية معلوماتك.",
    "id": "Kami mungkin memperbarui Kebijakan Privasi ini secara berkala untuk mencerminkan perubahan dalam praktik kami atau persyaratan hukum. Ketika kami membuat perubahan signifikan:\n\n• Anda akan diberi tahu melalui email atau notifikasi platform\n• Tanggal 'Terakhir Diperbarui' akan direvisi\n• Penggunaan platform yang berkelanjutan setelah perubahan merupakan penerimaan\n\nKami mendorong Anda untuk meninjau kebijakan ini secara teratur agar tetap terinformasi tentang bagaimana kami melindungi informasi Anda."
  },
  "privacy-section-11-title": {
    "en": "11. Contact Us",
    "ar": "11. اتصل بنا",
    "id": "11. Hubungi Kami"
  },
  "privacy-section-11-content": {
    "en": "If you have questions, concerns, or requests regarding this Privacy Policy or how your data is handled:\n\n• Contact your HR department\n• Reach out to the system administrator\n• Submit a privacy inquiry through the platform's support channels\n\nWe are committed to addressing your privacy concerns promptly and transparently.",
    "ar": "إذا كانت لديك أسئلة أو مخاوف أو طلبات بخصوص سياسة الخصوصية هذه أو كيفية التعامل مع بياناتك:\n\n• اتصل بقسم الموارد البشرية\n• تواصل مع مسؤول النظام\n• قدم استفسارًا عن الخصوصية من خلال قنوات دعم المنصة\n\nنحن ملتزمون بمعالجة مخاوفك المتعلقة بالخصوصية بسرعة وشفافية.",
    "id": "Jika Anda memiliki pertanyaan, kekhawatiran, atau permintaan mengenai Kebijakan Privasi ini atau bagaimana data Anda ditangani:\n\n• Hubungi departemen SDM Anda\n• Hubungi administrator sistem\n• Kirim pertanyaan privasi melalui saluran dukungan platform\n\nKami berkomitmen untuk menangani kekhawatiran privasi Anda dengan cepat dan transparan."
  },
  "terms-last-updated": {
    "en": "Dated: 1st January 2026",
    "ar": "التاريخ: 1 يناير 2026",
    "id": "Tanggal: 1 Januari 2026"
  },
  "terms-section-1-title": {
    "en": "1. Introduction to Privacy Policy",
    "ar": "1. مقدمة سياسة الخصوصية",
    "id": "1. Pengantar Kebijakan Privasi"
  },
  "terms-section-1-content": {
    "en": "This Privacy Policy outlines how SWB collects, uses, and discloses customers Personal Data in accordance with applicable laws, specifically the UAE Personal Data Protection Law (\"PDPL\"). We are committed to ensuring your privacy is protected and to complying with the PDPL to ensure transparency and trust in how your data is handled.",
    "ar": "توضح سياسة الخصوصية هذه كيفية قيام SWB بجمع واستخدام والإفصاح عن البيانات الشخصية للعملاء وفقًا للقوانين المعمول بها، وتحديدًا قانون حماية البيانات الشخصية في الإمارات العربية المتحدة (\"PDPL\"). نحن ملتزمون بضمان حماية خصوصيتك والامتثال لقانون PDPL لضمان الشفافية والثقة في كيفية التعامل مع بياناتك.",
    "id": "Kebijakan Privasi ini menguraikan bagaimana SWB mengumpulkan, menggunakan, dan mengungkapkan Data Pribadi pelanggan sesuai dengan hukum yang berlaku, khususnya Undang-Undang Perlindungan Data Pribadi UAE (\"PDPL\"). Kami berkomitmen untuk memastikan privasi Anda terlindungi dan mematuhi PDPL untuk memastikan transparansi dan kepercayaan dalam penanganan data Anda."
  },
  "terms-section-2-title": {
    "en": "2. Policy Scope",
    "ar": "2. نطاق السياسة",
    "id": "2. Ruang Lingkup Kebijakan"
  },
  "terms-section-2-content": {
    "en": "This Policy applies to SWB employees, clients, contractors, and third parties who either have a direct or indirect relationship with SWB Development LLC for the purpose of processing, sharing, or retaining Personal Data. This policy governs all individuals in the Kingdom of United Arab Emirates (\"UAE\") whose Personal Data may be processed by SWB Development LLC for legitimate purposes.",
    "ar": "تنطبق هذه السياسة على موظفي SWB والعملاء والمقاولين والأطراف الثالثة الذين لديهم علاقة مباشرة أو غير مباشرة مع SWB Development LLC لغرض معالجة البيانات الشخصية أو مشاركتها أو الاحتفاظ بها. تحكم هذه السياسة جميع الأفراد في دولة الإمارات العربية المتحدة الذين قد تتم معالجة بياناتهم الشخصية بواسطة SWB Development LLC لأغراض مشروعة.",
    "id": "Kebijakan ini berlaku untuk karyawan SWB, klien, kontraktor, dan pihak ketiga yang memiliki hubungan langsung atau tidak langsung dengan SWB Development LLC untuk tujuan pemrosesan, berbagi, atau penyimpanan Data Pribadi. Kebijakan ini mengatur semua individu di Uni Emirat Arab (\"UAE\") yang Data Pribadinya dapat diproses oleh SWB Development LLC untuk tujuan yang sah."
  },
  "terms-section-3-title": {
    "en": "3. Definitions",
    "ar": "3. التعريفات",
    "id": "3. Definisi"
  },
  "terms-section-3-content": {
    "en": "For the purposes of this Privacy Policy:\n\n• Account: A unique account created by or for You to access SWB Development LLC's Website or parts thereof.\n• Company: SWB Development LLC, United Arab Emirates, referred to as \"the Company,\" \"We,\" \"Us,\" or \"Our\" in this Policy.\n• Cookies: Small files placed on Your computer, mobile device, or any other device by a website containing details of Your browsing history on that website.\n• Country: United Arab Emirates \"UAE\".\n• Device: Any device that can access the Website such as a computer, cell phone, or digital tablet.\n• Personal Data: Any data that could lead to the identification of an individual directly or indirectly, including but not limited to: name, personal identification number, addresses, contact numbers, license numbers, records, personal property, bank account and credit card numbers, fixed or moving pictures of the individual, and other data of personal nature.\n• Website: www.swbai.com\n• Service Provider: Any natural or legal person who processes data on behalf of SWB Development LLC, including third-party companies or individuals employed by SWB Development LLC to facilitate the Website or business operations.\n• Third-party Social Media Service: Any website or social network where a User can log in or create an account to use the Service.\n• Usage Data: Data collected automatically, either generated by the Website or from the Website infrastructure itself (e.g., the duration of a page visit).\n• You: The individual accessing or using SWB Development LLC's Website, or any legal entity on whose behalf such individual is accessing or using the Website.",
    "ar": "لأغراض سياسة الخصوصية هذه:\n\n• الحساب: حساب فريد يتم إنشاؤه بواسطتك أو لك للوصول إلى موقع SWB Development LLC أو أجزاء منه.\n• الشركة: SWB Development LLC، الإمارات العربية المتحدة، يُشار إليها بـ \"الشركة\" أو \"نحن\" أو \"لنا\" في هذه السياسة.\n• ملفات تعريف الارتباط: ملفات صغيرة يتم وضعها على جهاز الكمبيوتر أو الجهاز المحمول أو أي جهاز آخر بواسطة موقع ويب تحتوي على تفاصيل سجل التصفح الخاص بك.\n• البلد: الإمارات العربية المتحدة.\n• الجهاز: أي جهاز يمكنه الوصول إلى الموقع مثل الكمبيوتر أو الهاتف المحمول أو الجهاز اللوحي الرقمي.\n• البيانات الشخصية: أي بيانات يمكن أن تؤدي إلى تحديد هوية الفرد بشكل مباشر أو غير مباشر.\n• الموقع: www.swbai.com\n• مزود الخدمة: أي شخص طبيعي أو اعتباري يعالج البيانات نيابة عن SWB Development LLC.\n• خدمة وسائل التواصل الاجتماعي التابعة لجهات خارجية: أي موقع ويب أو شبكة اجتماعية يمكن للمستخدم تسجيل الدخول أو إنشاء حساب فيها.\n• بيانات الاستخدام: البيانات التي يتم جمعها تلقائيًا من الموقع أو بنيته التحتية.\n• أنت: الفرد الذي يصل إلى موقع SWB Development LLC أو يستخدمه.",
    "id": "Untuk tujuan Kebijakan Privasi ini:\n\n• Akun: Akun unik yang dibuat oleh atau untuk Anda untuk mengakses Situs Web SWB Development LLC atau bagiannya.\n• Perusahaan: SWB Development LLC, Uni Emirat Arab, disebut sebagai \"Perusahaan,\" \"Kami,\" atau \"Milik Kami\" dalam Kebijakan ini.\n• Cookie: File kecil yang ditempatkan di komputer, perangkat seluler, atau perangkat lain oleh situs web yang berisi detail riwayat penjelajahan Anda.\n• Negara: Uni Emirat Arab \"UAE\".\n• Perangkat: Perangkat apa pun yang dapat mengakses Situs Web seperti komputer, ponsel, atau tablet digital.\n• Data Pribadi: Data apa pun yang dapat mengarah pada identifikasi individu secara langsung atau tidak langsung.\n• Situs Web: www.swbai.com\n• Penyedia Layanan: Orang atau badan hukum yang memproses data atas nama SWB Development LLC.\n• Layanan Media Sosial Pihak Ketiga: Situs web atau jaringan sosial tempat Pengguna dapat masuk atau membuat akun.\n• Data Penggunaan: Data yang dikumpulkan secara otomatis dari Situs Web atau infrastrukturnya.\n• Anda: Individu yang mengakses atau menggunakan Situs Web SWB Development LLC."
  },
  "terms-section-4-title": {
    "en": "4. Collecting & Using Personal Data",
    "ar": "4. جمع واستخدام البيانات الشخصية",
    "id": "4. Pengumpulan & Penggunaan Data Pribadi"
  },
  "terms-section-4-content": {
    "en": "At SWB Development LLC, we value your privacy and are committed to protecting your personal data in compliance with the UAE Personal Data Protection Law (PDPL).\n\nSWB Development LLC collects information about You through three primary methods:\n• Directly from customer input\n• From third-party sources\n• From our business partners\n\nData You Provide to Us:\nWe collect various categories of personal data based on our relationship with you, such as:\n\nFrom Customers:\n• Identification Information: Your name, date of birth (without year).\n• Contact Details: Phone number, email address, and shipping address.\n• Financial Information: Bank account details & transaction history.\n\nTracking Technologies and Cookies:\nSWB Development LLC's web services may automatically gather information on how you and your device interact with the Service, including:\n• Device Details: IP address, browser type, version, operating system, installed software, and mobile platform.\n• Usage Data: Features used, URL clickstream data (date/time stamps, referring/exit pages, and search terms used).\n• Location Data: For location-aware Services, information on the region, city, or town where Your device is located to provide relevant content.",
    "ar": "في SWB Development LLC، نحن نقدر خصوصيتك ونلتزم بحماية بياناتك الشخصية وفقًا لقانون حماية البيانات الشخصية في الإمارات.\n\nتجمع SWB Development LLC المعلومات عنك من خلال ثلاث طرق رئيسية:\n• مباشرة من مدخلات العملاء\n• من مصادر خارجية\n• من شركائنا التجاريين\n\nالبيانات التي تقدمها لنا:\nنجمع فئات مختلفة من البيانات الشخصية بناءً على علاقتنا بك:\n\nمن العملاء:\n• معلومات التعريف: اسمك وتاريخ ميلادك (بدون السنة).\n• تفاصيل الاتصال: رقم الهاتف وعنوان البريد الإلكتروني وعنوان الشحن.\n• المعلومات المالية: تفاصيل الحساب المصرفي وسجل المعاملات.\n\nتقنيات التتبع وملفات تعريف الارتباط:\nقد تجمع خدمات الويب الخاصة بنا تلقائيًا معلومات حول كيفية تفاعلك وجهازك مع الخدمة، بما في ذلك:\n• تفاصيل الجهاز: عنوان IP ونوع المتصفح والإصدار ونظام التشغيل.\n• بيانات الاستخدام: الميزات المستخدمة وبيانات تدفق النقرات.\n• بيانات الموقع: معلومات حول المنطقة أو المدينة التي يتواجد فيها جهازك.",
    "id": "Di SWB Development LLC, kami menghargai privasi Anda dan berkomitmen untuk melindungi data pribadi Anda sesuai dengan Undang-Undang Perlindungan Data Pribadi UAE (PDPL).\n\nSWB Development LLC mengumpulkan informasi tentang Anda melalui tiga metode utama:\n• Langsung dari input pelanggan\n• Dari sumber pihak ketiga\n• Dari mitra bisnis kami\n\nData yang Anda Berikan kepada Kami:\nKami mengumpulkan berbagai kategori data pribadi berdasarkan hubungan kami dengan Anda:\n\nDari Pelanggan:\n• Informasi Identifikasi: Nama, tanggal lahir (tanpa tahun).\n• Detail Kontak: Nomor telepon, alamat email, dan alamat pengiriman.\n• Informasi Keuangan: Detail rekening bank & riwayat transaksi.\n\nTeknologi Pelacakan dan Cookie:\nLayanan web SWB Development LLC dapat secara otomatis mengumpulkan informasi tentang bagaimana Anda dan perangkat Anda berinteraksi dengan Layanan, termasuk:\n• Detail Perangkat: Alamat IP, jenis browser, versi, sistem operasi.\n• Data Penggunaan: Fitur yang digunakan, data aliran klik URL.\n• Data Lokasi: Informasi tentang wilayah, kota tempat perangkat Anda berada."
  },
  "terms-section-5-title": {
    "en": "5. Purposes of Using Your Personal Data",
    "ar": "5. أغراض استخدام بياناتك الشخصية",
    "id": "5. Tujuan Penggunaan Data Pribadi Anda"
  },
  "terms-section-5-content": {
    "en": "Depending on interactions with SWB Development LLC, we may utilize your Personal Data for the following purposes:\n\n• Employment purpose\n• Managing Your requests\n• Commercial activities: Contacts, billing, sales invoicing, product delivery, order processing, payments for goods/services, permissible marketing activities, and supplier due diligence.\n• Website and Business Operations: Maintaining and operating our website and business, ensuring proper functionality.\n• Compliance with Legal Obligations: Resolving disputes, enforcing agreements, and complying with applicable laws and regulations.\n• Communications: Contacting you via email, telephone calls, SMS, or other means regarding updates, security updates, or informational communications related to products or services.",
    "ar": "بناءً على تفاعلاتك مع SWB Development LLC، قد نستخدم بياناتك الشخصية للأغراض التالية:\n\n• أغراض التوظيف\n• إدارة طلباتك\n• الأنشطة التجارية: الاتصالات والفواتير وتسليم المنتجات ومعالجة الطلبات والمدفوعات وأنشطة التسويق المسموح بها.\n• عمليات الموقع والأعمال: صيانة وتشغيل موقعنا وأعمالنا.\n• الامتثال للالتزامات القانونية: حل النزاعات وإنفاذ الاتفاقيات والامتثال للقوانين.\n• الاتصالات: الاتصال بك عبر البريد الإلكتروني أو المكالمات الهاتفية أو الرسائل القصيرة.",
    "id": "Tergantung pada interaksi dengan SWB Development LLC, kami dapat menggunakan Data Pribadi Anda untuk tujuan berikut:\n\n• Tujuan ketenagakerjaan\n• Mengelola permintaan Anda\n• Aktivitas komersial: Kontak, penagihan, faktur penjualan, pengiriman produk, pemrosesan pesanan, pembayaran, aktivitas pemasaran yang diizinkan.\n• Operasi Situs Web dan Bisnis: Memelihara dan mengoperasikan situs web dan bisnis kami.\n• Kepatuhan terhadap Kewajiban Hukum: Menyelesaikan perselisihan, menegakkan perjanjian, dan mematuhi hukum yang berlaku.\n• Komunikasi: Menghubungi Anda melalui email, panggilan telepon, SMS, atau cara lain."
  },
  "terms-section-6-title": {
    "en": "6. Disclosure/Sharing of Your Information",
    "ar": "6. الإفصاح/مشاركة معلوماتك",
    "id": "6. Pengungkapan/Pembagian Informasi Anda"
  },
  "terms-section-6-content": {
    "en": "SWB Development LLC may disclose Your Personal Data in the following circumstances:\n\n• With Your Consent: We may disclose Your Personal Data with explicit consent for purposes not covered here.\n• Compliance and Legal Obligations: To comply with applicable laws, legal processes, or investigate issues like fraud or security concerns.\n• With Service Providers: We may share your Personal Data with Service Providers to monitor, analyse, and improve our Service.",
    "ar": "قد تفصح SWB Development LLC عن بياناتك الشخصية في الظروف التالية:\n\n• بموافقتك: قد نفصح عن بياناتك الشخصية بموافقة صريحة لأغراض غير مشمولة هنا.\n• الامتثال والالتزامات القانونية: للامتثال للقوانين المعمول بها أو العمليات القانونية أو التحقيق في قضايا مثل الاحتيال.\n• مع مقدمي الخدمات: قد نشارك بياناتك الشخصية مع مقدمي الخدمات لمراقبة وتحليل وتحسين خدمتنا.",
    "id": "SWB Development LLC dapat mengungkapkan Data Pribadi Anda dalam keadaan berikut:\n\n• Dengan Persetujuan Anda: Kami dapat mengungkapkan Data Pribadi Anda dengan persetujuan eksplisit untuk tujuan yang tidak tercakup di sini.\n• Kepatuhan dan Kewajiban Hukum: Untuk mematuhi hukum yang berlaku, proses hukum, atau menyelidiki masalah seperti penipuan.\n• Dengan Penyedia Layanan: Kami dapat membagikan Data Pribadi Anda dengan Penyedia Layanan untuk memantau, menganalisis, dan meningkatkan Layanan kami."
  },
  "terms-section-7-title": {
    "en": "7. International Data Transfers",
    "ar": "7. نقل البيانات الدولية",
    "id": "7. Transfer Data Internasional"
  },
  "terms-section-7-content": {
    "en": "We do not store, process, or transmit your personal data outside of the Kingdom of United Arab Emirates (UAE). Should the need for international data transfer arise in the future, we will ensure that such transfers are made in full compliance with PDPL's requirements, including the implementation of appropriate safeguards.",
    "ar": "نحن لا نخزن أو نعالج أو ننقل بياناتك الشخصية خارج دولة الإمارات العربية المتحدة. في حال نشأت الحاجة لنقل البيانات دوليًا في المستقبل، سنضمن أن يتم هذا النقل بما يتوافق تمامًا مع متطلبات قانون PDPL، بما في ذلك تنفيذ الضمانات المناسبة.",
    "id": "Kami tidak menyimpan, memproses, atau mengirimkan data pribadi Anda di luar Uni Emirat Arab (UAE). Jika kebutuhan transfer data internasional muncul di masa depan, kami akan memastikan bahwa transfer tersebut dilakukan sesuai sepenuhnya dengan persyaratan PDPL, termasuk penerapan perlindungan yang sesuai."
  },
  "terms-section-8-title": {
    "en": "8. Data Retention & Destruction",
    "ar": "8. الاحتفاظ بالبيانات وإتلافها",
    "id": "8. Retensi & Penghancuran Data"
  },
  "terms-section-8-content": {
    "en": "Data Retention:\nWe retain Your Personal Data until it is made anonymous or destroyed as necessary to provide the Service, fulfil requested transactions, or for other essential purposes, including complying with legal obligations. Personal Data that is no longer necessary will be securely destroyed in accordance with our internal policies. Usage Data is generally retained for a shorter period unless retention is legally required or necessary for security enhancements or Service improvements.\n\nData Destruction:\nUpon the cessation of the purpose for which Your Personal Data was stored, SWB Development LLC will securely destroy it or anonymize it, subject to applicable laws. Should you request the deletion of Your Personal Data prior to this period, please contact us via the details provided below. Personal Data will be securely destroyed through methods such as encryption, deletion, or anonymization, in line with industry best practices.",
    "ar": "الاحتفاظ بالبيانات:\nنحتفظ ببياناتك الشخصية حتى يتم إخفاء هويتها أو إتلافها حسب الضرورة لتقديم الخدمة أو تنفيذ المعاملات المطلوبة أو لأغراض أساسية أخرى، بما في ذلك الامتثال للالتزامات القانونية. سيتم إتلاف البيانات الشخصية التي لم تعد ضرورية بشكل آمن وفقًا لسياساتنا الداخلية.\n\nإتلاف البيانات:\nعند انتهاء الغرض الذي تم تخزين بياناتك الشخصية من أجله، ستقوم SWB Development LLC بإتلافها بشكل آمن أو إخفاء هويتها، وفقًا للقوانين المعمول بها. إذا طلبت حذف بياناتك الشخصية قبل هذه الفترة، يرجى الاتصال بنا عبر التفاصيل المقدمة أدناه.",
    "id": "Retensi Data:\nKami menyimpan Data Pribadi Anda hingga dianonimkan atau dihancurkan sebagaimana diperlukan untuk menyediakan Layanan, memenuhi transaksi yang diminta, atau untuk tujuan penting lainnya, termasuk mematuhi kewajiban hukum. Data Pribadi yang tidak lagi diperlukan akan dihancurkan dengan aman sesuai dengan kebijakan internal kami.\n\nPenghancuran Data:\nSetelah berakhirnya tujuan penyimpanan Data Pribadi Anda, SWB Development LLC akan menghancurkannya dengan aman atau menganonimkannya, sesuai dengan hukum yang berlaku. Jika Anda meminta penghapusan Data Pribadi Anda sebelum periode ini, silakan hubungi kami melalui detail yang disediakan di bawah."
  },
  "terms-section-9-title": {
    "en": "9. Data Security",
    "ar": "9. أمان البيانات",
    "id": "9. Keamanan Data"
  },
  "terms-section-9-content": {
    "en": "We have implemented appropriate technical, physical, and managerial procedures to safeguard and secure your Personal Data. These measures include encryption, access controls, and audit trails to ensure that your data is protected from unauthorized access, alteration, or destruction. We continuously monitor our systems to ensure the security of your data.",
    "ar": "لقد طبقنا إجراءات تقنية ومادية وإدارية مناسبة لحماية وتأمين بياناتك الشخصية. تشمل هذه التدابير التشفير وضوابط الوصول ومسارات التدقيق لضمان حماية بياناتك من الوصول غير المصرح به أو التغيير أو الإتلاف. نراقب أنظمتنا باستمرار لضمان أمان بياناتك.",
    "id": "Kami telah menerapkan prosedur teknis, fisik, dan manajerial yang sesuai untuk melindungi dan mengamankan Data Pribadi Anda. Langkah-langkah ini mencakup enkripsi, kontrol akses, dan jejak audit untuk memastikan data Anda terlindungi dari akses, perubahan, atau penghancuran yang tidak sah. Kami terus memantau sistem kami untuk memastikan keamanan data Anda."
  },
  "terms-section-10-title": {
    "en": "10. Your Rights",
    "ar": "10. حقوقك",
    "id": "10. Hak Anda"
  },
  "terms-section-10-content": {
    "en": "As the owner of Personal Data under applicable law, you have the following rights as defined in the PDPL (Personal Data Protection Law):\n\n• Right to Information: Know the purpose and justification for collecting Your Personal Data.\n• Right to Access: Request access to and obtain a clear and comprehensive copy of Your Personal Data.\n• Right to Rectification: Request correction, completion, or updating of Your Personal Data.\n• Right to Erasure: Request deletion of Your Personal Data, subject to legal provisions.\n• Right to Objection: You may object to the processing of Your Personal Data for marketing or based on legitimate interests, in accordance with the PDPL.\n• Right to Data Portability: Request a copy of Your Personal Data in a structured, commonly used, and machine-readable format for transfer to another data controller.",
    "ar": "بصفتك مالك البيانات الشخصية بموجب القانون المعمول به، لديك الحقوق التالية كما هو محدد في قانون PDPL:\n\n• الحق في المعلومات: معرفة غرض ومبرر جمع بياناتك الشخصية.\n• الحق في الوصول: طلب الوصول إلى نسخة واضحة وشاملة من بياناتك الشخصية والحصول عليها.\n• الحق في التصحيح: طلب تصحيح أو استكمال أو تحديث بياناتك الشخصية.\n• الحق في المحو: طلب حذف بياناتك الشخصية، وفقًا للأحكام القانونية.\n• الحق في الاعتراض: يمكنك الاعتراض على معالجة بياناتك الشخصية لأغراض التسويق أو بناءً على المصالح المشروعة.\n• الحق في نقل البيانات: طلب نسخة من بياناتك الشخصية بتنسيق منظم وشائع الاستخدام وقابل للقراءة آليًا.",
    "id": "Sebagai pemilik Data Pribadi berdasarkan hukum yang berlaku, Anda memiliki hak-hak berikut sebagaimana didefinisikan dalam PDPL:\n\n• Hak atas Informasi: Mengetahui tujuan dan justifikasi pengumpulan Data Pribadi Anda.\n• Hak Akses: Meminta akses dan mendapatkan salinan yang jelas dan komprehensif dari Data Pribadi Anda.\n• Hak Rektifikasi: Meminta koreksi, penyelesaian, atau pembaruan Data Pribadi Anda.\n• Hak Penghapusan: Meminta penghapusan Data Pribadi Anda, tunduk pada ketentuan hukum.\n• Hak Keberatan: Anda dapat menolak pemrosesan Data Pribadi Anda untuk pemasaran atau berdasarkan kepentingan yang sah.\n• Hak Portabilitas Data: Meminta salinan Data Pribadi Anda dalam format terstruktur, umum digunakan, dan dapat dibaca mesin."
  },
  "terms-section-11-title": {
    "en": "11. Personal Data Protection Officer",
    "ar": "11. مسؤول حماية البيانات الشخصية",
    "id": "11. Petugas Perlindungan Data Pribadi"
  },
  "terms-section-11-content": {
    "en": "You can contact our Data Protection Officer to exercise your rights or for inquiries regarding your Personal Data at:\n\n• Email Address: info@swbai.com",
    "ar": "يمكنك الاتصال بمسؤول حماية البيانات لدينا لممارسة حقوقك أو للاستفسارات المتعلقة ببياناتك الشخصية على:\n\n• عنوان البريد الإلكتروني: info@swbai.com",
    "id": "Anda dapat menghubungi Petugas Perlindungan Data kami untuk menggunakan hak Anda atau untuk pertanyaan mengenai Data Pribadi Anda di:\n\n• Alamat Email: info@swbai.com"
  },
  "terms-section-12-title": {
    "en": "12. Changes to this Privacy Policy",
    "ar": "12. التغييرات على سياسة الخصوصية هذه",
    "id": "12. Perubahan pada Kebijakan Privasi Ini"
  },
  "terms-section-12-content": {
    "en": "We may update this Privacy Policy periodically. Any changes will be published on this page with a revised date. Please review this Privacy Policy periodically for updates. Changes become effective upon posting on this page. Significant changes to this policy will be communicated via email or other prominent notices.",
    "ar": "قد نقوم بتحديث سياسة الخصوصية هذه بشكل دوري. سيتم نشر أي تغييرات على هذه الصفحة بتاريخ منقح. يرجى مراجعة سياسة الخصوصية هذه بشكل دوري للاطلاع على التحديثات. تصبح التغييرات سارية المفعول عند نشرها على هذه الصفحة. سيتم إبلاغ التغييرات الجوهرية عبر البريد الإلكتروني أو إشعارات بارزة أخرى.",
    "id": "Kami dapat memperbarui Kebijakan Privasi ini secara berkala. Perubahan apa pun akan dipublikasikan di halaman ini dengan tanggal yang direvisi. Harap tinjau Kebijakan Privasi ini secara berkala untuk pembaruan. Perubahan berlaku efektif setelah diposting di halaman ini. Perubahan signifikan pada kebijakan ini akan dikomunikasikan melalui email atau pemberitahuan penting lainnya."
  },
  "trending-empty-title": {
    "en": "No Trending Ads Found",
    "ar": "لا يوجد إعلانات",
    "id": "Tidak ada iklan"
  },
  "trending-empty-description": {
    "en": "No trending ads found",
    "ar": "لا يوجد إعلانات",
    "id": "Tidak ada iklan"
  },
  "recommended-empty-title": {
    "en": "No Recommended Ads Found",
    "ar": "لا يوجد إعلانات",
    "id": "Tidak ada iklan"
  },
  "recommended-empty-description": {
    "en": "No recommended ads found",
    "ar": "لا يوجد إعلانات",
    "id": "Tidak ada iklan"
  },
  "trending-now": {
    "en": "Trending Now",
    "ar": "النافذة الحالية",
    "id": "Sedang Beken"
  },
  "trending-now-description": {
    "en": "New apartment added from around the city with variety facilities available",
    "ar": "تم إضافة شقة جديدة من حول المدينة مع ميزات مختلفة",
    "id": "Tambahan apartemen baru dari sekitar kota dengan fasilitas yang beragam"
  },
  "recommended-for-you": {
    "en": "Top picks for You",
    "ar": "أفضل الاختيارات لك",
    "id": "Disarankan untuk Anda"
  },
  "recommended-for-you-description": {
    "en": "New apartment added from around the city with variety facilities available",
    "ar": "تم إضافة شقة جديدة من حول المدينة مع ميزات مختلفة",
    "id": "Tambahan apartemen baru dari sekitar kota dengan fasilitas yang beragam"
  },
  "favorite": {
    "en": "Favorite",
    "ar": "المفضل",
    "id": "Favorit"
  },
  "see-all": {
    "en": "See All",
    "ar": "عرض الكل",
    "id": "Lihat Semua"
  },
  "empty-state-ads": {
    "en": "No ads found",
    "ar": "لا يوجد إعلانات",
    "id": "Tidak ada iklan"
  },
  "empty-state-ads-description": {
    "en": "Oops! We couldn&apos;t find any products that match your search. Try searching for something else.",
    "ar": "عذراً! لم يتم العثور على أي منتجات تطابق بحثك. حاول البحث عن شيء آخر.",
    "id": "Oops! We couldn't find any products that match your search. Try searching for something else."
  },
  "faq-1-title": {
    "en": "What is the refund policy?",
    "ar": "ما هي سياسة الاسترداد؟",
    "id": "Apa kebijakan pengembalian dana?"
  },
  "faq-1-content": {
    "en": "The refund policy is as follows: ...",
    "ar": "سياسة الاسترداد هي كما يلي: ...",
    "id": "Kebijakan pengembalian dana adalah sebagai berikut: ..."
  },
  "faq-2-title": {
    "en": "How can I contact customer support?",
    "ar": "كيف يمكنني التواصل مع دعم العملاء؟",
    "id": "Bagaimana cara menghubungi dukungan pelanggan?"
  },
  "faq-2-content": {
    "en": "You can contact customer support at support@example.com or through our live chat.",
    "ar": "يمكنك التواصل مع دعم العملاء على support@example.com أو من خلال الدردشة المباشرة.",
    "id": "Anda dapat menghubungi dukungan pelanggan di support@example.com atau melalui obrolan langsung kami."
  },
  "data-deletion-title": {
    "en": "Data Deletion Request",
    "ar": "طلب حذف البيانات",
    "id": "Permintaan Penghapusan Data"
  },
  "data-deletion-last-updated": {
    "en": "Last Updated:",
    "ar": "آخر تحديث:",
    "id": "Terakhir Diperbarui:"
  },
  "data-deletion-section-1-title": {
    "en": "Account and Data Deletion",
    "ar": "حذف الحساب والبيانات",
    "id": "Penghapusan Akun dan Data"
  },
  "data-deletion-section-1-content": {
    "en": "We respect your right to control your personal data. If you wish to delete your account and all associated data from our HR Management mobile application, you can submit a deletion request using the methods outlined below.",
    "ar": "نحن نحترم حقك في التحكم في بياناتك الشخصية. إذا كنت ترغب في حذف حسابك وجميع البيانات المرتبطة به من تطبيق إدارة الموارد البشرية للهاتف المحمول، يمكنك تقديم طلب حذف باستخدام الطرق الموضحة أدناه.",
    "id": "Kami menghormati hak Anda untuk mengontrol data pribadi Anda. Jika Anda ingin menghapus akun dan semua data terkait dari aplikasi seluler Manajemen SDM kami, Anda dapat mengajukan permintaan penghapusan menggunakan metode yang dijelaskan di bawah ini."
  },
  "data-deletion-section-2-title": {
    "en": "What Data Will Be Deleted?",
    "ar": "ما البيانات التي سيتم حذفها؟",
    "id": "Data Apa yang Akan Dihapus?"
  },
  "data-deletion-section-2-intro": {
    "en": "When you request account deletion, the following data will be permanently removed:",
    "ar": "عند طلب حذف الحساب، سيتم إزالة البيانات التالية بشكل دائم:",
    "id": "Ketika Anda meminta penghapusan akun, data berikut akan dihapus secara permanen:"
  },
  "data-deletion-section-2-item-1": {
    "en": "Personal profile information (name, email, phone number)",
    "ar": "معلومات الملف الشخصي (الاسم، البريد الإلكتروني، رقم الهاتف)",
    "id": "Informasi profil pribadi (nama, email, nomor telepon)"
  },
  "data-deletion-section-2-item-2": {
    "en": "Login credentials and authentication data",
    "ar": "بيانات اعتماد تسجيل الدخول وبيانات المصادقة",
    "id": "Kredensial login dan data otentikasi"
  },
  "data-deletion-section-2-item-3": {
    "en": "Employment records and work history",
    "ar": "سجلات التوظيف وتاريخ العمل",
    "id": "Catatan ketenagakerjaan dan riwayat kerja"
  },
  "data-deletion-section-2-item-4": {
    "en": "Uploaded documents and files",
    "ar": "المستندات والملفات المرفوعة",
    "id": "Dokumen dan file yang diunggah"
  },
  "data-deletion-section-2-item-5": {
    "en": "Usage history and activity logs",
    "ar": "سجل الاستخدام وسجلات النشاط",
    "id": "Riwayat penggunaan dan log aktivitas"
  },
  "data-deletion-section-2-item-6": {
    "en": "Communications and messages within the app",
    "ar": "الاتصالات والرسائل داخل التطبيق",
    "id": "Komunikasi dan pesan dalam aplikasi"
  },
  "data-deletion-section-2-item-7": {
    "en": "Preferences and settings",
    "ar": "التفضيلات والإعدادات",
    "id": "Preferensi dan pengaturan"
  },
  "data-deletion-section-3-title": {
    "en": "Data Retention",
    "ar": "الاحتفاظ بالبيانات",
    "id": "Retensi Data"
  },
  "data-deletion-section-3-intro": {
    "en": "Please note that certain data may be retained for legal and compliance purposes:",
    "ar": "يرجى ملاحظة أنه قد يتم الاحتفاظ ببعض البيانات لأغراض قانونية وتنظيمية:",
    "id": "Harap dicatat bahwa data tertentu mungkin disimpan untuk tujuan hukum dan kepatuhan:"
  },
  "data-deletion-section-3-item-1": {
    "en": "Financial records (payroll, tax documents) may be retained as required by law (typically 3-7 years)",
    "ar": "قد يتم الاحتفاظ بالسجلات المالية (الرواتب، المستندات الضريبية) كما يقتضي القانون (عادةً 3-7 سنوات)",
    "id": "Catatan keuangan (penggajian, dokumen pajak) mungkin disimpan sesuai yang diwajibkan oleh hukum (biasanya 3-7 tahun)"
  },
  "data-deletion-section-3-item-2": {
    "en": "Records required for legal proceedings or regulatory compliance",
    "ar": "السجلات المطلوبة للإجراءات القانونية أو الامتثال التنظيمي",
    "id": "Catatan yang diperlukan untuk proses hukum atau kepatuhan peraturan"
  },
  "data-deletion-section-3-item-3": {
    "en": "Anonymized data for analytics and reporting purposes (with no personal identifiers)",
    "ar": "البيانات المجهولة الهوية لأغراض التحليل والتقارير (بدون معرفات شخصية)",
    "id": "Data anonim untuk tujuan analitik dan pelaporan (tanpa pengidentifikasi pribadi)"
  },
  "data-deletion-section-4-title": {
    "en": "How to Request Data Deletion",
    "ar": "كيفية طلب حذف البيانات",
    "id": "Cara Meminta Penghapusan Data"
  },
  "data-deletion-section-4-intro": {
    "en": "You can request deletion of your account and data through the following methods:",
    "ar": "يمكنك طلب حذف حسابك وبياناتك من خلال الطرق التالية:",
    "id": "Anda dapat meminta penghapusan akun dan data Anda melalui metode berikut:"
  },
  "data-deletion-method-1-title": {
    "en": "Method 1: In-App Request",
    "ar": "الطريقة الأولى: طلب من داخل التطبيق",
    "id": "Metode 1: Permintaan Dalam Aplikasi"
  },
  "data-deletion-method-1-step-1": {
    "en": "Open the mobile application",
    "ar": "افتح تطبيق الهاتف المحمول",
    "id": "Buka aplikasi seluler"
  },
  "data-deletion-method-1-step-2": {
    "en": "Go to Settings or Profile",
    "ar": "انتقل إلى الإعدادات أو الملف الشخصي",
    "id": "Buka Pengaturan atau Profil"
  },
  "data-deletion-method-1-step-3": {
    "en": "Select \"Account Settings\"",
    "ar": "اختر \"إعدادات الحساب\"",
    "id": "Pilih \"Pengaturan Akun\""
  },
  "data-deletion-method-1-step-4": {
    "en": "Choose \"Delete Account\"",
    "ar": "اختر \"حذف الحساب\"",
    "id": "Pilih \"Hapus Akun\""
  },
  "data-deletion-method-1-step-5": {
    "en": "Follow the on-screen instructions to confirm",
    "ar": "اتبع التعليمات التي تظهر على الشاشة للتأكيد",
    "id": "Ikuti petunjuk di layar untuk mengkonfirmasi"
  },
  "data-deletion-method-2-title": {
    "en": "Method 2: Email Request",
    "ar": "الطريقة الثانية: طلب عبر البريد الإلكتروني",
    "id": "Metode 2: Permintaan Email"
  },
  "data-deletion-method-2-intro": {
    "en": "Send an email to your HR department or system administrator with the subject line \"Data Deletion Request\" including:",
    "ar": "أرسل بريدًا إلكترونيًا إلى قسم الموارد البشرية أو مسؤول النظام مع موضوع \"طلب حذف البيانات\" متضمنًا:",
    "id": "Kirim email ke departemen SDM atau administrator sistem Anda dengan baris subjek \"Permintaan Penghapusan Data\" termasuk:"
  },
  "data-deletion-method-2-item-1": {
    "en": "Your full name",
    "ar": "اسمك الكامل",
    "id": "Nama lengkap Anda"
  },
  "data-deletion-method-2-item-2": {
    "en": "Registered email address",
    "ar": "عنوان البريد الإلكتروني المسجل",
    "id": "Alamat email terdaftar"
  },
  "data-deletion-method-2-item-3": {
    "en": "Employee ID (if applicable)",
    "ar": "رقم الموظف (إن وجد)",
    "id": "ID Karyawan (jika ada)"
  },
  "data-deletion-method-2-item-4": {
    "en": "Reason for deletion (optional)",
    "ar": "سبب الحذف (اختياري)",
    "id": "Alasan penghapusan (opsional)"
  },
  "data-deletion-method-3-title": {
    "en": "Method 3: Contact HR Department",
    "ar": "الطريقة الثالثة: التواصل مع قسم الموارد البشرية",
    "id": "Metode 3: Hubungi Departemen SDM"
  },
  "data-deletion-method-3-content": {
    "en": "Contact your organization's HR department directly via phone, email, or in-person to submit your deletion request. They will guide you through the process and verify your identity.",
    "ar": "تواصل مع قسم الموارد البشرية في مؤسستك مباشرة عبر الهاتف أو البريد الإلكتروني أو شخصيًا لتقديم طلب الحذف. سيرشدونك خلال العملية ويتحققون من هويتك.",
    "id": "Hubungi departemen SDM organisasi Anda langsung melalui telepon, email, atau secara langsung untuk mengajukan permintaan penghapusan Anda. Mereka akan memandu Anda melalui proses dan memverifikasi identitas Anda."
  },
  "data-deletion-section-5-title": {
    "en": "Processing Timeline",
    "ar": "الجدول الزمني للمعالجة",
    "id": "Jadwal Pemrosesan"
  },
  "data-deletion-section-5-intro": {
    "en": "Once we receive your deletion request:",
    "ar": "بمجرد استلام طلب الحذف الخاص بك:",
    "id": "Setelah kami menerima permintaan penghapusan Anda:"
  },
  "data-deletion-section-5-item-1": {
    "en": "We will verify your identity to protect against unauthorized deletion requests",
    "ar": "سنتحقق من هويتك للحماية من طلبات الحذف غير المصرح بها",
    "id": "Kami akan memverifikasi identitas Anda untuk melindungi dari permintaan penghapusan yang tidak sah"
  },
  "data-deletion-section-5-item-2": {
    "en": "Your request will be processed within 30 days of verification",
    "ar": "سيتم معالجة طلبك في غضون 30 يومًا من التحقق",
    "id": "Permintaan Anda akan diproses dalam 30 hari setelah verifikasi"
  },
  "data-deletion-section-5-item-3": {
    "en": "You will receive confirmation once the deletion is complete",
    "ar": "ستتلقى تأكيدًا بمجرد اكتمال الحذف",
    "id": "Anda akan menerima konfirmasi setelah penghapusan selesai"
  },
  "data-deletion-section-5-item-4": {
    "en": "During processing, your account will be deactivated and you will not be able to access the application",
    "ar": "أثناء المعالجة، سيتم إلغاء تفعيل حسابك ولن تتمكن من الوصول إلى التطبيق",
    "id": "Selama pemrosesan, akun Anda akan dinonaktifkan dan Anda tidak akan dapat mengakses aplikasi"
  },
  "data-deletion-section-6-title": {
    "en": "Important Considerations",
    "ar": "اعتبارات مهمة",
    "id": "Pertimbangan Penting"
  },
  "data-deletion-section-6-intro": {
    "en": "Before requesting deletion, please note:",
    "ar": "قبل طلب الحذف، يرجى ملاحظة:",
    "id": "Sebelum meminta penghapusan, harap perhatikan:"
  },
  "data-deletion-section-6-item-1-title": {
    "en": "Irreversible Action:",
    "ar": "إجراء لا رجعة فيه:",
    "id": "Tindakan Tidak Dapat Dibatalkan:"
  },
  "data-deletion-section-6-item-1-content": {
    "en": "Account deletion is permanent and cannot be undone. All your data will be lost.",
    "ar": "حذف الحساب دائم ولا يمكن التراجع عنه. ستفقد جميع بياناتك.",
    "id": "Penghapusan akun bersifat permanen dan tidak dapat dibatalkan. Semua data Anda akan hilang."
  },
  "data-deletion-section-6-item-2-title": {
    "en": "Active Employment:",
    "ar": "التوظيف النشط:",
    "id": "Pekerjaan Aktif:"
  },
  "data-deletion-section-6-item-2-content": {
    "en": "If you are currently employed, deleting your account may affect your access to important HR services and information.",
    "ar": "إذا كنت موظفًا حاليًا، فإن حذف حسابك قد يؤثر على وصولك إلى خدمات ومعلومات الموارد البشرية المهمة.",
    "id": "Jika Anda saat ini bekerja, menghapus akun Anda dapat mempengaruhi akses Anda ke layanan dan informasi SDM yang penting."
  },
  "data-deletion-section-6-item-3-title": {
    "en": "Pending Transactions:",
    "ar": "المعاملات المعلقة:",
    "id": "Transaksi Tertunda:"
  },
  "data-deletion-section-6-item-3-content": {
    "en": "Complete any pending actions (leave requests, expense claims, etc.) before deletion.",
    "ar": "أكمل أي إجراءات معلقة (طلبات الإجازة، مطالبات المصروفات، إلخ) قبل الحذف.",
    "id": "Selesaikan tindakan yang tertunda (permintaan cuti, klaim pengeluaran, dll.) sebelum penghapusan."
  },
  "data-deletion-section-6-item-4-title": {
    "en": "Data Export:",
    "ar": "تصدير البيانات:",
    "id": "Ekspor Data:"
  },
  "data-deletion-section-6-item-4-content": {
    "en": "Consider downloading your data before requesting deletion, as this option will not be available afterward.",
    "ar": "فكر في تنزيل بياناتك قبل طلب الحذف، حيث لن يكون هذا الخيار متاحًا بعد ذلك.",
    "id": "Pertimbangkan untuk mengunduh data Anda sebelum meminta penghapusan, karena opsi ini tidak akan tersedia setelahnya."
  },
  "data-deletion-section-7-title": {
    "en": "Alternative Options",
    "ar": "خيارات بديلة",
    "id": "Opsi Alternatif"
  },
  "data-deletion-section-7-intro": {
    "en": "If you don't want to permanently delete your account, consider these alternatives:",
    "ar": "إذا كنت لا تريد حذف حسابك بشكل دائم، فكر في هذه البدائل:",
    "id": "Jika Anda tidak ingin menghapus akun Anda secara permanen, pertimbangkan alternatif ini:"
  },
  "data-deletion-section-7-item-1-title": {
    "en": "Account Deactivation:",
    "ar": "إلغاء تفعيل الحساب:",
    "id": "Penonaktifan Akun:"
  },
  "data-deletion-section-7-item-1-content": {
    "en": "Temporarily disable your account without deleting data",
    "ar": "تعطيل حسابك مؤقتًا دون حذف البيانات",
    "id": "Nonaktifkan akun Anda sementara tanpa menghapus data"
  },
  "data-deletion-section-7-item-2-title": {
    "en": "Update Privacy Settings:",
    "ar": "تحديث إعدادات الخصوصية:",
    "id": "Perbarui Pengaturan Privasi:"
  },
  "data-deletion-section-7-item-2-content": {
    "en": "Limit data collection and visibility",
    "ar": "تقييد جمع البيانات وظهورها",
    "id": "Batasi pengumpulan dan visibilitas data"
  },
  "data-deletion-section-7-item-3-title": {
    "en": "Data Export:",
    "ar": "تصدير البيانات:",
    "id": "Ekspor Data:"
  },
  "data-deletion-section-7-item-3-content": {
    "en": "Download your data for personal records",
    "ar": "تنزيل بياناتك للسجلات الشخصية",
    "id": "Unduh data Anda untuk catatan pribadi"
  },
  "data-deletion-section-8-title": {
    "en": "Contact Information",
    "ar": "معلومات الاتصال",
    "id": "Informasi Kontak"
  },
  "data-deletion-section-8-intro": {
    "en": "If you have questions about the data deletion process or need assistance:",
    "ar": "إذا كانت لديك أسئلة حول عملية حذف البيانات أو تحتاج إلى مساعدة:",
    "id": "Jika Anda memiliki pertanyaan tentang proses penghapusan data atau membutuhkan bantuan:"
  },
  "data-deletion-section-8-item-1": {
    "en": "Contact your HR department",
    "ar": "تواصل مع قسم الموارد البشرية",
    "id": "Hubungi departemen SDM Anda"
  },
  "data-deletion-section-8-item-2": {
    "en": "Email your system administrator",
    "ar": "راسل مسؤول النظام عبر البريد الإلكتروني",
    "id": "Email administrator sistem Anda"
  },
  "data-deletion-section-8-item-3": {
    "en": "Submit a support ticket through the application",
    "ar": "قدم تذكرة دعم من خلال التطبيق",
    "id": "Kirim tiket dukungan melalui aplikasi"
  },
  "data-deletion-privacy-rights-title": {
    "en": "Your Privacy Rights:",
    "ar": "حقوق الخصوصية الخاصة بك:",
    "id": "Hak Privasi Anda:"
  },
  "data-deletion-privacy-rights-content": {
    "en": "We are committed to respecting your privacy rights and handling your data deletion request promptly and securely. For more information about how we handle your data, please review our",
    "ar": "نحن ملتزمون باحترام حقوق الخصوصية الخاصة بك ومعالجة طلب حذف بياناتك بسرعة وأمان. لمزيد من المعلومات حول كيفية تعاملنا مع بياناتك، يرجى مراجعة",
    "id": "Kami berkomitmen untuk menghormati hak privasi Anda dan menangani permintaan penghapusan data Anda dengan cepat dan aman. Untuk informasi lebih lanjut tentang bagaimana kami menangani data Anda, silakan tinjau"
  },
  "data-deletion-privacy-policy-link": {
    "en": "Privacy Policy",
    "ar": "سياسة الخصوصية",
    "id": "Kebijakan Privasi"
  },
  "schedules-title": {
    "en": "Scheduled Appointments",
    "ar": "المواعيد المجدولة",
    "id": "Jadwal Pertemuan"
  },
  "schedules-owner": {
    "en": "(Owner)",
    "ar": "(المالك)",
    "id": "(Pemilik)"
  },
  "schedules-no-interviews": {
    "en": "No interviews found",
    "ar": "لم يتم العثور على مقابلات",
    "id": "Tidak ada wawancara ditemukan"
  },
  "schedules-no-status-interviews": {
    "en": "No {{status}} interviews found",
    "ar": "لم يتم العثور على مقابلات {{status}}",
    "id": "Tidak ada wawancara {{status}} ditemukan"
  },
  "schedules-view-details": {
    "en": "View Details",
    "ar": "عرض التفاصيل",
    "id": "Lihat Detail"
  },
  "schedules-reschedule": {
    "en": "Reschedule",
    "ar": "إعادة الجدولة",
    "id": "Jadwalkan Ulang"
  },
  "schedules-reschedule-dialog-title": {
    "en": "Reschedule Interview",
    "ar": "إعادة جدولة المقابلة",
    "id": "Jadwalkan Ulang Wawancara"
  },
  "schedules-na": {
    "en": "N/A",
    "ar": "غير متاح",
    "id": "Tidak Tersedia"
  },
  "following-no-content-title": {
    "en": "No Content Available",
    "ar": "لا يوجد محتوى متاح",
    "id": "Tidak Ada Konten Tersedia"
  },
  "following-no-content-description": {
    "en": "No videos available from people you follow.",
    "ar": "لا توجد مقاطع فيديو متاحة من الأشخاص الذين تتابعهم.",
    "id": "Tidak ada video tersedia dari orang yang Anda ikuti."
  },
  "sidebar-home": {
    "en": "Home",
    "ar": "الرئيسية",
    "id": "Beranda"
  },
  "sidebar-following": {
    "en": "Following",
    "ar": "المتابعون",
    "id": "Mengikuti"
  },
  "sidebar-schedule": {
    "en": "Schedule",
    "ar": "الجدول",
    "id": "Jadwal"
  },
  "sidebar-comparison": {
    "en": "Comparison",
    "ar": "المقارنة",
    "id": "Perbandingan"
  },
  "sidebar-jobs": {
    "en": "Jobs",
    "ar": "الوظائف",
    "id": "Lowongan"
  },
  "profile-jobs-title": {
    "en": "Jobs",
    "ar": "الوظائف",
    "id": "Lowongan"
  },
  "profile-jobs-available": {
    "en": "Job Available",
    "ar": "وظيفة متاحة",
    "id": "Lowongan Tersedia"
  },
  "profile-jobs-empty": {
    "en": "No jobs found for this profile.",
    "ar": "لم يتم العثور على وظائف لهذا الملف الشخصي.",
    "id": "Tidak ada lowongan ditemukan untuk profil ini."
  },
  "sign-up": {
    "en": "Sign Up",
    "ar": "التسجيل",
    "id": "Daftar"
  },
  "who-we-are": {
    "en": "Who We Are",
    "ar": "من نحن",
    "id": "Tentang Kami"
  },
  "contact-us": {
    "en": "Contact Us",
    "ar": "اتصل بنا",
    "id": "Hubungi Kami"
  },
  "login": {
    "en": "Login",
    "ar": "تسجيل الدخول",
    "id": "Masuk"
  },
  "share": {
    "en": "Share",
    "ar": "مشاركة",
    "id": "Bagikan"
  },
  "requirement": {
    "en": "Requirement:",
    "ar": "المتطلبات:",
    "id": "Persyaratan:"
  },
  "see-more": {
    "en": "See More",
    "ar": "عرض المزيد",
    "id": "Lihat Lebih"
  },
  "less": {
    "en": "Less",
    "ar": "أقل",
    "id": "Lebih Sedikit"
  },
  "apply-now": {
    "en": "Apply Now",
    "ar": "تقدم الآن",
    "id": "Lamar Sekarang"
  },
  "tab-profiles": {
    "en": "Profiles",
    "ar": "الملفات الشخصية",
    "id": "Profil"
  },
  "tab-all": {
    "en": "All",
    "ar": "الكل",
    "id": "Semua"
  },
  "tab-jobs": {
    "en": "Jobs",
    "ar": "الوظائف",
    "id": "Lowongan"
  },
  "suggested-to-follow": {
    "en": "Suggested to follow",
    "ar": "مقترح للمتابعة",
    "id": "Disarankan untuk diikuti"
  },
  "follow": {
    "en": "Follow",
    "ar": "متابعة",
    "id": "Ikuti"
  },
  "who-we-are-title": {
    "en": "Who We Are",
    "ar": "من نحن",
    "id": "Tentang Kami"
  },
  "about-company": {
    "en": "About",
    "ar": "حول",
    "id": "Tentang"
  },
  "about-company-description": {
    "en": "Company description will appear here.",
    "ar": "سيظهر وصف الشركة هنا.",
    "id": "Deskripsi perusahaan akan muncul di sini."
  },
  "services-and-products": {
    "en": "Services and products offered",
    "ar": "الخدمات والمنتجات المقدمة",
    "id": "Layanan dan produk yang ditawarkan"
  },
  "services-and-products-description": {
    "en": "Services and products description will appear here.",
    "ar": "سيظهر وصف الخدمات والمنتجات هنا.",
    "id": "Deskripsi layanan dan produk akan muncul di sini."
  },
  "company-vision-mission": {
    "en": "Company Vision & Mission",
    "ar": "رؤية ومهمة الشركة",
    "id": "Visi & Misi Perusahaan"
  },
  "company-vision-mission-description": {
    "en": "Company vision and mission will appear here.",
    "ar": "ستظهر رؤية ومهمة الشركة هنا.",
    "id": "Visi dan misi perusahaan akan muncul di sini."
  },
  "what-we-do-title": {
    "en": "What We Do In Our Company",
    "ar": "ما نقوم به في شركتنا",
    "id": "Apa yang Kami Lakukan di Perusahaan Kami"
  },
  "what-we-do-subtitle": {
    "en": "Comprehensive solutions tailored for modern business needs.",
    "ar": "حلول شاملة مصممة لتلبية احتياجات الأعمال الحديثة.",
    "id": "Solusi komprehensif yang disesuaikan untuk kebutuhan bisnis modern."
  },
  "service-data-analytics": {
    "en": "Data Analytics",
    "ar": "تحليل البيانات",
    "id": "Analisis Data"
  },
  "service-data-analytics-desc": {
    "en": "Turning complex data into actionable insights for strategic decision making.",
    "ar": "تحويل البيانات المعقدة إلى رؤى قابلة للتنفيذ لاتخاذ قرارات استراتيجية.",
    "id": "Mengubah data kompleks menjadi wawasan yang dapat ditindaklanjuti untuk pengambilan keputusan strategis."
  },
  "service-cloud-solutions": {
    "en": "Cloud Solutions",
    "ar": "حلول سحابية",
    "id": "Solusi Cloud"
  },
  "service-cloud-solutions-desc": {
    "en": "Scalable cloud infrastructure to support your growing business needs.",
    "ar": "بنية سحابية قابلة للتوسع لدعم احتياجات عملك المتنامية.",
    "id": "Infrastruktur cloud yang skalabel untuk mendukung kebutuhan bisnis Anda yang berkembang."
  },
  "service-cyber-security": {
    "en": "Cyber Security",
    "ar": "الأمن السيبراني",
    "id": "Keamanan Siber"
  },
  "service-cyber-security-desc": {
    "en": "Protecting your digital assets with state-of-the-art security protocols.",
    "ar": "حماية أصولك الرقمية بأحدث بروتوكولات الأمان.",
    "id": "Melindungi aset digital Anda dengan protokol keamanan mutakhir."
  },
  "service-app-development": {
    "en": "App Development",
    "ar": "تطوير التطبيقات",
    "id": "Pengembangan Aplikasi"
  },
  "service-app-development-desc": {
    "en": "Creating seamless mobile and web experiences for your users.",
    "ar": "إنشاء تجارب سلسة للهاتف المحمول والويب لمستخدميك.",
    "id": "Menciptakan pengalaman mobile dan web yang mulus untuk pengguna Anda."
  },
  "service-ai-integration": {
    "en": "AI Integration",
    "ar": "دمج الذكاء الاصطناعي",
    "id": "Integrasi AI"
  },
  "service-ai-integration-desc": {
    "en": "Leveraging artificial intelligence to automate and optimize workflows.",
    "ar": "الاستفادة من الذكاء الاصطناعي لأتمتة وتحسين سير العمل.",
    "id": "Memanfaatkan kecerdasan buatan untuk mengotomatisasi dan mengoptimalkan alur kerja."
  },
  "service-it-consultancy": {
    "en": "IT Consultancy",
    "ar": "استشارات تكنولوجيا المعلومات",
    "id": "Konsultasi IT"
  },
  "service-it-consultancy-desc": {
    "en": "Expert advice to guide your technology strategy and digital transformation.",
    "ar": "نصائح خبراء لتوجيه استراتيجيتك التقنية والتحول الرقمي.",
    "id": "Saran ahli untuk memandu strategi teknologi dan transformasi digital Anda."
  },
  "get-in-touch": {
    "en": "Get in touch",
    "ar": "تواصل معنا",
    "id": "Hubungi Kami"
  },
  "get-in-touch-description": {
    "en": "Have questions about our services or need support? We're here to help. Reach out to our team using the contact details below or fill out the form.",
    "ar": "هل لديك أسئلة حول خدماتنا أو تحتاج إلى دعم؟ نحن هنا للمساعدة. تواصل مع فريقنا باستخدام تفاصيل الاتصال أدناه أو املأ النموذج.",
    "id": "Punya pertanyaan tentang layanan kami atau butuh dukungan? Kami siap membantu. Hubungi tim kami menggunakan detail kontak di bawah atau isi formulir."
  },
  "chat-to-us": {
    "en": "Chat to us",
    "ar": "تحدث إلينا",
    "id": "Hubungi kami"
  },
  "chat-to-us-desc": {
    "en": "Our friendly team is here to help.",
    "ar": "فريقنا الودود هنا للمساعدة.",
    "id": "Tim ramah kami siap membantu."
  },
  "phone": {
    "en": "Phone",
    "ar": "الهاتف",
    "id": "Telepon"
  },
  "phone-desc": {
    "en": "Mon-Fri from 8am to 5pm.",
    "ar": "من الاثنين إلى الجمعة من 8 صباحاً إلى 5 مساءً.",
    "id": "Senin-Jumat dari jam 8 pagi sampai 5 sore."
  },
  "office": {
    "en": "Office",
    "ar": "المكتب",
    "id": "Kantor"
  },
  "office-desc": {
    "en": "Come say hello at our office HQ.",
    "ar": "تعال وقل مرحباً في مقرنا الرئيسي.",
    "id": "Datang dan sapa kami di kantor pusat kami."
  },
  "name": {
    "en": "Name",
    "ar": "الاسم",
    "id": "Nama"
  },
  "name-placeholder": {
    "en": "Your full name",
    "ar": "اسمك الكامل",
    "id": "Nama lengkap Anda"
  },
  "email-address": {
    "en": "Email Address",
    "ar": "عنوان البريد الإلكتروني",
    "id": "Alamat Email"
  },
  "email-placeholder": {
    "en": "you@company.com",
    "ar": "you@company.com",
    "id": "you@company.com"
  },
  "subject": {
    "en": "Subject",
    "ar": "الموضوع",
    "id": "Subjek"
  },
  "subject-placeholder": {
    "en": "How can we help?",
    "ar": "كيف يمكننا المساعدة؟",
    "id": "Bagaimana kami bisa membantu?"
  },
  "message": {
    "en": "Message",
    "ar": "الرسالة",
    "id": "Pesan"
  },
  "message-placeholder": {
    "en": "Tell us a little about your project...",
    "ar": "أخبرنا قليلاً عن مشروعك...",
    "id": "Ceritakan sedikit tentang proyek Anda..."
  },
  "send-message": {
    "en": "Send Message",
    "ar": "إرسال الرسالة",
    "id": "Kirim Pesan"
  },
  "profile-login-welcome": {
    "en": "Welcome Back",
    "ar": "مرحباً بعودتك",
    "id": "Selamat Datang Kembali"
  },
  "profile-login-subtitle": {
    "en": "Please enter your details to sign in.",
    "ar": "يرجى إدخال بياناتك لتسجيل الدخول.",
    "id": "Silakan masukkan detail Anda untuk masuk."
  },
  "profile-login-password": {
    "en": "Password",
    "ar": "كلمة المرور",
    "id": "Kata Sandi"
  },
  "profile-login-password-placeholder": {
    "en": "Enter your password",
    "ar": "أدخل كلمة المرور",
    "id": "Masukkan kata sandi Anda"
  },
  "profile-login-email-placeholder": {
    "en": "Enter your email",
    "ar": "أدخل بريدك الإلكتروني",
    "id": "Masukkan email Anda"
  },
  "profile-login-forgot-password": {
    "en": "Forgot Password?",
    "ar": "نسيت كلمة المرور؟",
    "id": "Lupa Kata Sandi?"
  },
  "profile-login-button": {
    "en": "Log In",
    "ar": "تسجيل الدخول",
    "id": "Masuk"
  },
  "profile-login-button-loading": {
    "en": "Logging In...",
    "ar": "جارٍ تسجيل الدخول...",
    "id": "Sedang Masuk..."
  },
  "profile-login-or-continue": {
    "en": "Or continue with",
    "ar": "أو تابع مع",
    "id": "Atau lanjutkan dengan"
  },
  "profile-login-google": {
    "en": "Log in with Google",
    "ar": "تسجيل الدخول بجوجل",
    "id": "Masuk dengan Google"
  },
  "profile-login-no-account": {
    "en": "Don't have an account?",
    "ar": "ليس لديك حساب؟",
    "id": "Belum punya akun?"
  },
  "profile-login-validation-email": {
    "en": "Invalid email format",
    "ar": "صيغة البريد الإلكتروني غير صالحة",
    "id": "Format email tidak valid"
  },
  "profile-login-validation-password": {
    "en": "Password must be at least 6 characters",
    "ar": "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
    "id": "Kata sandi harus minimal 6 karakter"
  },
  "action-like": {
    "en": "Like",
    "ar": "إعجاب",
    "id": "Suka"
  },
  "action-comment": {
    "en": "Comment",
    "ar": "تعليق",
    "id": "Komentar"
  },
  "action-save": {
    "en": "Save",
    "ar": "حفظ",
    "id": "Simpan"
  },
  "action-support": {
    "en": "Support",
    "ar": "دعم",
    "id": "Dukungan"
  }
}
